import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmModalComponent } from '@fgb/portal-component-library/src/lib/shared/confirm-modal';
import { TermsAndCondtionsType, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@ngx-translate/core';

function ConfirmModalTermsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementContainer(1, 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.imageRef);
} }
function ConfirmModalTermsComponent_ng_container_5_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 17);
    ɵngcc0.ɵɵlistener("click", function ConfirmModalTermsComponent_ng_container_5_a_8_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); const _r2 = ɵngcc0.ɵɵreference(14); return ctx_r6.openTerms(_r2); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "confirm.terms.text"), " ");
} }
function ConfirmModalTermsComponent_ng_container_5_a_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("href", ctx_r5.termsLink, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 2, "confirm.terms.url"), " ");
} }
function ConfirmModalTermsComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "input", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function ConfirmModalTermsComponent_ng_container_5_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.termsAccepted = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 13);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 14);
    ɵngcc0.ɵɵtemplate(8, ConfirmModalTermsComponent_ng_container_5_a_8_Template, 3, 3, "a", 15);
    ɵngcc0.ɵɵtemplate(9, ConfirmModalTermsComponent_ng_container_5_a_9_Template, 3, 4, "a", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.termsAccepted);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 4, "confirm.terms.agree"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.termsAndCondtions.termsAndCondtionsType === ctx_r1.TermsAndCondtionsType.Text);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.termsAndCondtions.termsAndCondtionsType === ctx_r1.TermsAndCondtionsType.URL);
} }
function ConfirmModalTermsComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵelementStart(2, "p", 20);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "hr", 21);
    ɵngcc0.ɵɵelementStart(6, "div", 3);
    ɵngcc0.ɵɵelementStart(7, "div", 22);
    ɵngcc0.ɵɵelementStart(8, "p", 23);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 24);
    ɵngcc0.ɵɵelementStart(11, "button", 25);
    ɵngcc0.ɵɵlistener("click", function ConfirmModalTermsComponent_ng_template_13_Template_button_click_11_listener() { const modal_r10 = ctx.$implicit; return modal_r10.dismiss("close"); });
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 3, "confirm.terms.title"));
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.termsAndCondtions.termsAndCondtions);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 5, "confirm.terms.close"), " ");
} }
class ConfirmModalTermsComponent extends ConfirmModalComponent {
    constructor(router, modalService) {
        super();
        this.router = router;
        this.modalService = modalService;
        this.termsAccepted = false;
        this.TermsAndCondtionsType = TermsAndCondtionsType;
    }
    ngOnInit() {
        if (this.termsAndCondtions) {
            this.termsAccepted = !this.termsAndCondtions.showTermsAndCondtions;
            if (this.termsAndCondtions.termsAndCondtionsType === TermsAndCondtionsType.Text) {
                this.termsLink = this.router.url + '/terms';
            }
            else {
                this.termsLink = this.termsAndCondtions.termsAndCondtions;
            }
        }
    }
    confirmClick() {
        if (this.termsAccepted) {
            this.confirm.emit('confirm');
        }
    }
    openTerms(content) {
        this.modalService.open(content, { centered: true });
    }
}
ConfirmModalTermsComponent.ɵfac = function ConfirmModalTermsComponent_Factory(t) { return new (t || ConfirmModalTermsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgbModal)); };
ConfirmModalTermsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConfirmModalTermsComponent, selectors: [["fgbcl-confirm-modal-terms"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 15, vars: 10, consts: [[1, "d-block", "d-lg-flex"], ["class", "modal-image flex-grow-0 flex-shrink-0", 4, "ngIf"], [1, "d-flex", "flex-column", "justify-content-between", "flex-grow-1", "flex-shrink-1"], [1, "modal-body"], [3, "ngTemplateOutlet"], [4, "ngIf"], [1, "modal-footer", "d-flex", "justify-content-between", "border-0"], ["type", "button", 1, "btn", "btn-danger", "font-weight-bold", 3, "click"], ["type", "button", 1, "btn", "btn-success", "font-weight-bold", 3, "disabled", "click"], ["termsDetails", ""], [1, "modal-image", "flex-grow-0", "flex-shrink-0"], [1, "terms"], ["type", "checkbox", 3, "ngModel", "ngModelChange"], [1, "state"], [1, "links"], ["target", "_blank", "class", "cursor-pointer text-primary", 3, "click", 4, "ngIf"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 1, "cursor-pointer", "text-primary", 3, "click"], ["target", "_blank", 3, "href"], [1, "modal-header", "border-bottom-0", "pb-0"], [1, "terms-title", "mx-auto"], [1, "mt-0", "mb-2", "mx-5"], [1, "mb-4", "px-4"], [1, "terms-info"], [1, "text-center"], [1, "btn", "btn-terms-close", "font-weight-bold", "close-terms", 3, "click"]], template: function ConfirmModalTermsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ConfirmModalTermsComponent_div_1_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementContainer(4, 4);
        ɵngcc0.ɵɵtemplate(5, ConfirmModalTermsComponent_ng_container_5_Template, 10, 6, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "button", 7);
        ɵngcc0.ɵɵlistener("click", function ConfirmModalTermsComponent_Template_button_click_7_listener() { return ctx.close.emit("close"); });
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 8);
        ɵngcc0.ɵɵlistener("click", function ConfirmModalTermsComponent_Template_button_click_10_listener() { return ctx.confirmClick(); });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(13, ConfirmModalTermsComponent_ng_template_13_Template, 14, 7, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.imageRef);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.modalContent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.termsAndCondtions && ctx.termsAndCondtions.showTermsAndCondtions);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(9, 6, "confirm.terms.cancel"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.termsAccepted);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(12, 8, "confirm.terms.confirm"), " ");
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgTemplateOutlet, ɵngcc4.CheckboxControlValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], pipes: [ɵngcc5.TranslatePipe], styles: [".modal-body[_ngcontent-%COMP%], .modal-footer[_ngcontent-%COMP%]{font-size:14px}.modal-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-width:142px;width:100%;font-size:.875rem}.terms[_ngcontent-%COMP%]{position:relative;display:inline-block}.terms[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{position:absolute;left:0;top:0;min-width:1em;width:100%;height:100%;z-index:2;opacity:0;margin:0;padding:0;cursor:pointer}.terms[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{text-indent:30px;font-size:.825rem;margin:0}.terms[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:after, .terms[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:before{content:\"\";width:20px;height:20px;border:1px solid transparent;position:absolute;left:0;transform:translateY(-50%);top:50%;background-color:transparent;border-radius:20%}.terms[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:before{border-color:#000}.terms[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .state[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:after{background-color:#000!important;transform:translateY(-50%) scale(.8)}.links[_ngcontent-%COMP%]{display:inline}"] });
ConfirmModalTermsComponent.ctorParameters = () => [
    { type: Router },
    { type: NgbModal }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfirmModalTermsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-confirm-modal-terms',
                template: "<div class=\"d-block d-lg-flex\">\r\n  <div *ngIf=\"imageRef\" class=\"modal-image flex-grow-0 flex-shrink-0\">\r\n    <ng-container [ngTemplateOutlet]=\"imageRef\"></ng-container>\r\n  </div>\r\n\r\n  <div class=\"d-flex flex-column justify-content-between flex-grow-1 flex-shrink-1\">\r\n    <div class=\"modal-body\">\r\n      <ng-container [ngTemplateOutlet]=\"modalContent\"></ng-container>\r\n\r\n      <ng-container *ngIf=\"termsAndCondtions && termsAndCondtions.showTermsAndCondtions\">\r\n        <div class=\"terms\">\r\n          <input type=\"checkbox\" [(ngModel)]=\"termsAccepted\" />\r\n          <div class=\"state\">\r\n            <label> {{ 'confirm.terms.agree' | translate }} </label>\r\n          </div>\r\n        </div>\r\n        <div class=\"links\">\r\n          <a\r\n            target=\"_blank\"\r\n            *ngIf=\"termsAndCondtions.termsAndCondtionsType === TermsAndCondtionsType.Text\"\r\n            (click)=\"openTerms(termsDetails)\"\r\n            class=\"cursor-pointer text-primary\"\r\n          >\r\n            {{ 'confirm.terms.text' | translate }}\r\n          </a>\r\n          <a target=\"_blank\" *ngIf=\"termsAndCondtions.termsAndCondtionsType === TermsAndCondtionsType.URL\" [href]=\"termsLink\">\r\n            {{ 'confirm.terms.url' | translate }}\r\n          </a>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n\r\n    <div class=\"modal-footer d-flex justify-content-between border-0\">\r\n      <button type=\"button\" class=\"btn btn-danger font-weight-bold\" (click)=\"close.emit('close')\">\r\n        {{ 'confirm.terms.cancel' | translate }}\r\n      </button>\r\n      <button type=\"button\" [disabled]=\"!termsAccepted\" class=\"btn btn-success font-weight-bold\" (click)=\"confirmClick()\">\r\n        {{ 'confirm.terms.confirm' | translate }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--terms modal-->\r\n<ng-template #termsDetails let-modal>\r\n  <div>\r\n    <div class=\"modal-header border-bottom-0 pb-0\">\r\n      <p class=\"terms-title mx-auto\">{{ 'confirm.terms.title' | translate }}</p>\r\n    </div>\r\n    <hr class=\"mt-0 mb-2 mx-5\" />\r\n    <div class=\"modal-body\">\r\n      <div class=\"mb-4 px-4\">\r\n        <p class=\"terms-info\">{{ termsAndCondtions.termsAndCondtions }}</p>\r\n      </div>\r\n      <div class=\"text-center\">\r\n        <button class=\"btn btn-terms-close font-weight-bold close-terms\" (click)=\"modal.dismiss('close')\">\r\n          {{ 'confirm.terms.close' | translate }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                styles: [".modal-body,.modal-footer{font-size:14px}.modal-footer button{max-width:142px;width:100%;font-size:.875rem}.terms{position:relative;display:inline-block}.terms input{position:absolute;left:0;top:0;min-width:1em;width:100%;height:100%;z-index:2;opacity:0;margin:0;padding:0;cursor:pointer}.terms label{text-indent:30px;font-size:.825rem;margin:0}.terms .state label:after,.terms .state label:before{content:\"\";width:20px;height:20px;border:1px solid transparent;position:absolute;left:0;transform:translateY(-50%);top:50%;background-color:transparent;border-radius:20%}.terms .state label:before{border-color:#000}.terms input:checked~.state label:after{background-color:#000!important;transform:translateY(-50%) scale(.8)}.links{display:inline}"]
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc2.NgbModal }]; }, null); })();

class ConfirmModalTermsModule {
}
ConfirmModalTermsModule.ɵfac = function ConfirmModalTermsModule_Factory(t) { return new (t || ConfirmModalTermsModule)(); };
ConfirmModalTermsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ConfirmModalTermsModule });
ConfirmModalTermsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ConfirmModalTermsModule, { declarations: function () { return [ConfirmModalTermsComponent]; }, imports: function () { return [CommonModule,
        FormsModule, ɵngcc5.TranslateModule]; }, exports: function () { return [ConfirmModalTermsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfirmModalTermsModule, [{
        type: NgModule,
        args: [{
                declarations: [ConfirmModalTermsComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [ConfirmModalTermsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ConfirmModalTermsComponent, ConfirmModalTermsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-confirm-modal-terms.js.map